import { createTheme } from "@mui/material";

export const customTheme = createTheme({
  palette: {
    primary: {
      main: "#1b5c29",
    },
    secondary: {
      main: "#b8dbc0",
    },
  },
});
